import React from 'react';

import { LOADING_STATE_TEST_ID } from 'App/DetailsPage/DetailsPage.test-ids';
import MobileColumn from 'assets/placeholder/mobile-column.svg';
import PrimaryContentColumn from 'assets/placeholder/primary-content-column.svg';
import SideBarColumn from 'assets/placeholder/side-bar-column.svg';

import styles from './LoadingState.module.scss';

const LoadingState: React.FC = () => (
  <div className={styles.details} data-testid={LOADING_STATE_TEST_ID}>
    <PrimaryContentColumn className={styles.leftColumn} />
    <SideBarColumn className={styles.rightColumn} />
    <MobileColumn className={styles.mobileColumn} />

    <div className={styles.placeholder}>
      <div className={styles.summaryPanel}>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
      </div>

      <div className={styles.trackingPanel}>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.circle}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.circle}> </div>
        <div className={styles.circle}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
      </div>

      <div className={styles.dialogueCards}>
        <div className={styles.circle}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
      </div>

      <div className={styles.sidePanel}>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
        <div className={styles.line}> </div>
      </div>
    </div>
  </div>
);

export default LoadingState;
